export default __webpack_public_path__ + "static/media/expl_14_DE.0cfdf8a0.png";